<template>
    <section class="mb-8">
        <slot></slot>
    </section>
</template>